import styled from "styled-components";

import { motion } from "framer-motion";

export const StyledContactItem = styled(motion.li)`
  width: 16.8125rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 1px solid white;
  border-radius: 8px;
  padding: 2rem;
  color: white;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: white;
    color: black;
    transform: scale(1.1);
    img {
      display: block;
    }
  }
`;

export const Title = styled.h2``;

export const Info = styled.p``;

export const CopyClipboard = styled.img`
  display: none;
  position: absolute;
  width: 2rem;
  right: 0.5rem;
  top: 0.5rem;
`;
